import CoinList from "../containers/AssetList"

export default () => {
    return (
        <CoinList/>
    )
}
